export default {
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
    updateEmployee(state, payload) {
        state.Employee = payload;
    },
    updateEmployees(state, payload) {
        state.Employees = payload;
    }
}